function Loader() {

    return <div class="custom-loader"></div>
   
    
   
}
export default Loader;
  